import { camelize } from 'casing'
import { camelizeKeyValueObject } from './camelizeKeyValueObject'

export const camelizeSalesforceReferralTemplate = (data: any) => {
  return {
    ...camelize(data),
    fieldMappings: {
      ...camelize(data?.field_mappings ?? {}),
      fields: {
        fieldsMapping: {
          ...Object.fromEntries(
            Object.entries(
              data?.field_mappings?.fields?.fields_mapping ?? {}
            ).map(([key, value]) => {
              return [key, camelize(value)]
            })
          ),
        },
      },
      installments: {
        installmentsMapping: {
          ...camelizeKeyValueObject(
            data?.field_mappings?.installments?.installments_mapping ?? {}
          ),
        },
      },
      metadata: {
        metadataMapping: {
          ...camelizeKeyValueObject(
            data?.field_mappings?.metadata?.metadata_mapping ?? {}
          ),
        },
      },
      recipientSource: {
        recipientSourceMapping: {
          ...camelizeKeyValueObject(
            data?.field_mappings?.recipient_source?.recipient_source_mapping ??
              {}
          ),
        },
      },
      dimensions: {
        dimensionsMapping: {
          ...Object.fromEntries(
            Object.entries(
              data?.field_mappings?.dimensions?.dimensions_mapping ?? {}
            ).map(([key, value]) => {
              const updatedValue = {
                ...camelize(value as Record<string, unknown>),
                dimensions: {
                  ...Object.fromEntries(
                    Object.entries(
                      ((value as Record<string, unknown>)?.dimensions ||
                        {}) as Record<string, unknown>
                    ).map(([key, value]) => {
                      return [key, camelize(value)]
                    })
                  ),
                },
              }
              return [key, updatedValue]
            })
          ),
        },
      },
    },
  }
}
